export default __webpack_public_path__ + "static/media/frame2c.cf374400.PNG";